export default {
  data: () => ({
    Sell: {
      key: 'S',
      value: 'Zakup odpadu'
    },
    FreeUtilisation: {
      key: 'F',
      value: 'Utylizacja bezpłatna'
    },
    PaidUtilisation: {
      key: 'P',
      value: 'Utylizacja płatna'
    }
  }),
  methods: {
    getTransactionTypes() {
      return [this.Sell, this.FreeUtilisation, this.PaidUtilisation]
    },
    getTransactionTypeLabel(value) {
      return this.getTransactionTypes().find((tc) => tc.key === value).value
    },
    isFreeUtilisationTransactionType(value) {
      return this.FreeUtilisation.key === value
    },
    getTransactionTypePaymentDesc(value) {
      return this.Sell.key === value
        ? 'Sprzedaż odpadu - otrzymasz:'
        : 'Płatana utylizacja - zapłacisz:'
    }
  }
}
